import { toast } from "react-toastify"
import PnLBudgetAPI from "../../../api/pnlBudget"
import { pnlBudgetType } from "./types"
import { useResponseHandle } from "../../hooks"

const API = new PnLBudgetAPI()

export const getPnlBudget = async (params: any) => {
  const { token, dispatch, loading } = params
  const { group, selectedClass, year } = params

  if (token) {
    const args = {
      classId: selectedClass?.class_id,
      groupSk: group?.group_sk || null,
      year: year?.label,
    }
    console.log("getPnlBudget args:", args)
    const response = await API.getPnlBudget({ args, token })
    if (
      response?.data?.status_code != 200 &&
      response?.data?.status_code != 401
    ) {
      toast.error(response?.data?.display_message)
    } else {
      if (!response?.data?.data?.monthly_budget_list) {
        toast.info(
          `Budget doesn't exist for the selected class ${
            selectedClass?.label || ""
          } and year ${args.year}`,
        )
      }
      dispatch(response?.data?.data)
    }
  }
  loading(false)
}

export const updateBudget = async (params: any) => {
  const { token, loading } = params
  if (token) {
    const { state, dispatch, selectedClass } = params
    const { dirtyCells, budgetData, budgetYear } = state as pnlBudgetType
    loading(true)

    const updateList: any = dirtyCells.map((id) => {
      const [row, month, _] = id.split("_").map((el) => parseInt(el))

      console.log("parseFloat(budgetData[row][`${month}_amount`])", budgetData)

      let budgetAmount = parseFloat(budgetData[row][`${month}_amount`])

      if (!month) {
        budgetAmount = parseFloat(budgetData[row][`${month}_amount`])
      }

      return {
        budget_year: budgetYear,
        budget_month: month,
        line_item: budgetData[row].line_item,
        class_id: selectedClass?.class_id,
        budget_amount: parseFloat(budgetData[row][`${month}_amount`]),
      }
    })

    const payload = { Data: updateList }
    const response = await API.saveBudgetData({ token, payload })
    if (
      response?.data?.status_code != 200 &&
      response?.data?.status_code != 401
    ) {
      toast.error(response?.data?.display_message)
    } else {
      toast.success("P&L Budget table saved successfully")
      dispatch(response?.data?.data)
    }
  }
  loading(false)
}

export const getYears = async (params: any) => {
  const { token, navigate, dispatch, loading } = params

  if (token) {
    loading(true)
    try {
      console.log("Fetching years from API...")
      const response = await API.getBudgetYears(token)

      console.log("Raw API response:", response)

      const result = useResponseHandle({
        apiResponse: response,
        successMessage: false,
      })

      console.log("Years API response:", result)

      if (result?.isAuthorized) {
        if (result?.statusCode == 200) {
          let tempYears: any = []

          if (result?.data && Array.isArray(result.data)) {
            result.data.forEach((year: any) => {
              tempYears.push({ label: year })
            })
          } else {
            console.warn("No years data or invalid format:", result?.data)
          }

          // Sort years in descending order (most recent first)
          tempYears.sort((a: any, b: any) => {
            const yearA = parseInt(a.label)
            const yearB = parseInt(b.label)
            return yearB - yearA
          })

          console.log("Processed years:", tempYears)
          dispatch([...tempYears])
        } else {
          console.warn("API returned non-200 status:", result?.statusCode)
        }
      } else {
        console.warn("Not authorized, navigating to auth")
        navigate("/auth")
      }
    } catch (error) {
      console.error("Error fetching years:", error)
    } finally {
      console.log("Setting loading to false")
      loading(false)
    }
  } else {
    console.log("No token, setting loading to false")
    loading(false)
  }
}
